/**
 * The fabric status vocabulary — a small lookup collection owned by the API.
 *
 * Fabrics store a `status` HANDLE (`coming_soon`); this vocabulary owns what that
 * handle means (label, note) and where fabrics carrying it are allowed to appear
 * (visibility). Staff type a label; the handle is derived server-side and never
 * shown, so renaming a label is free — it rewrites zero fabrics.
 */

export enum StatusVisibility {
  /** Everyone: public site, Shade Designer, order form. */
  Public = "public",
  /** Staff browsing the client apps as Admin, plus this tool. */
  Staff = "staff",
  /** This tool only. Withheld from every catalog query. */
  Internal = "internal",
}

export interface IFabricStatus {
  _id?: string;
  handle: string;
  label: string;
  note?: string;
  visibility: StatusVisibility;
  sort_order?: number;
  /** Built-in statuses. Renameable, but not deletable. */
  is_system?: boolean;
}

export const VISIBILITY_OPTIONS: {
  value: StatusVisibility;
  label: string;
  hint: string;
}[] = [
  {
    value: StatusVisibility.Public,
    label: "Public",
    hint: "Customers see these fabrics everywhere — the website, Shade Designer and the order form.",
  },
  {
    value: StatusVisibility.Staff,
    label: "Staff only",
    hint: "Hidden from customers. Visible to admins in the client apps, and here.",
  },
  {
    value: StatusVisibility.Internal,
    label: "Fabric Manager only",
    hint: "Withheld everywhere, including admin views in the client apps. Only visible here.",
  },
];

export function visibilityLabel(v?: StatusVisibility | string): string {
  return VISIBILITY_OPTIONS.find((o) => o.value === v)?.label || String(v || "—");
}
